export const REQUEST_SINISTER_INSPECTION =
  '@@SINISTER_INSPECTION/REQUEST_SINISTER_INSPECTION';
export const SUCCESS_SINISTER_INSPECTION =
  '@@SINISTER_INSPECTION/SUCCESS_SINISTER_INSPECTION';
export const FAILURE_SINISTER_INSPECTION =
  '@@SINISTER_INSPECTION/FAILURE_SINISTER_INSPECTION';

export const REQUEST_SINISTER_INSPECTION_BY_ID =
  '@@SINISTER_INSPECTION_BY_ID/REQUEST_SINISTER_INSPECTION_BY_ID';
export const SUCCESS_SINISTER_INSPECTION_BY_ID =
  '@@SINISTER_INSPECTION_BY_ID/SUCCESS_SINISTER_INSPECTION_BY_ID';
export const FAILURE_SINISTER_INSPECTION_BY_ID =
  '@@SINISTER_INSPECTION_BY_ID/FAILURE_SINISTER_INSPECTION_BY_ID';

export const REQUEST_UPLOAD_PHOTO = '@@SINISTER/REQUEST_UPLOAD_PHOTO';
export const SUCCESS_UPLOAD_PHOTO = '@@SINISTER/SUCCESS_UPLOAD_PHOTO';
export const FAILURE_UPLOAD_PHOTO = '@@SINISTER/FAILURE_UPLOAD_PHOTO';
export const UPDATE_SINISTER_INSPECTION_BODY =
  '@@SINISTER_INSPECTION/UPDATE_SINISTER_INSPECTION_BODY';

export const CLEAN_SINISTER_INSPECTION_SUCCESS =
  '@@SINISTER_INSPECTION/CLEAN_SINISTER_INSPECTION_SUCCESS';

export default (state: any, action: any) => {
  switch (action.type) {
    case REQUEST_SINISTER_INSPECTION:
      return {
        ...state,
      };

    case SUCCESS_SINISTER_INSPECTION:
      return {
        ...state,
        sinister_inspection: action.payload,
      };

    case FAILURE_SINISTER_INSPECTION:
      return {
        ...state,
        sinister_inspections: [],
      };

    case REQUEST_SINISTER_INSPECTION_BY_ID:
      return {
        ...state,
        loading: true,
      };

    case SUCCESS_SINISTER_INSPECTION_BY_ID:
      return {
        ...state,
        errors: {},
        success: {},
        loading: false,
        sinister_inspection_selected: { ...action.payload },
      };

    case FAILURE_SINISTER_INSPECTION_BY_ID:
      return {
        ...state,
        errors: {},
        success: {},
        loading: false,
        sinister_inspection_selected: {},
      };

    case REQUEST_UPLOAD_PHOTO:
      const image_preview = [...state.image_preview];
      image_preview.push(action.payload);
      return {
        ...state,
        image_preview,
        loading: true,
        errors: {},
        success: {},
      };

    case SUCCESS_UPLOAD_PHOTO:
      return {
        ...state,
        success: {
          photo: action.payload,
        },
        errors: {},
        loading: false,
        sinister_inspection_body: {
          ...state.sinister_inspection_body,
          photo: {
            ...state.sinister_inspection_body,
            ...action.payload,
          },
        },
      };

    case FAILURE_UPLOAD_PHOTO:
      return {
        ...state,
        errors: {
          photo: action.payload,
        },
        success: {},
        loading: false,
      };

    case UPDATE_SINISTER_INSPECTION_BODY:
      return {
        ...state,
        errors: {},
        success: {},
        sinister_inspection_body: {
          ...state.sinister_inspection_body,
          ...action.payload,
        },
      };

    case CLEAN_SINISTER_INSPECTION_SUCCESS:
      return {
        ...state,
        errors: {},
        success: {},
        sinister_inspection_body: {
          ...state.sinister_inspection_body,
        },
      };

    default:
      return state;
  }
};
